@if (!password()) {
  <mat-form-field
    appearance="outline"
    class="sia-inputs-full sia-input"
    floatLabel="always"
    [class]="inputClass()"
    [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
  >
    <mat-label
      >{{ label() | siaTranslate }}
      @if (info()) {
        <span
          [siaTooltip]="info() ?? ''"
          position="right"
          class="sia-info"
          [innerHTML]="infoIcon()"
        >
        </span>
      }
    </mat-label>
    <textarea
      [siaTooltip]="fieldErrors()"
      [disable]="!visibleTooltip()"
      rows="1"
      style="overflow: hidden; resize: none"
      #box
      [id]="id() ?? guid"
      matInput
      [ngModel]="value()"
      (ngModelChange)="value.set($event)"
      [disabled]="isDisabled()"
      [isLast]="true"
      (ngInit)="initTextBox()"
      (blur)="onBlur()"
      [placeholder]="placeholder() ?? ''"
      [name]="name() ?? ''"
      autocomplete="on"
      [tabindex]="tabDisabled() ? '-1' : '0'"
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="50"
    ></textarea>
    @if (showBottomMargin()) {
      <mat-hint
        sia-error-hint
        [statusMessage]="statusMessage()"
        [statusMessages]="statusMessages()"
      ></mat-hint>
    }
  </mat-form-field>
}
@if (password()) {
  <mat-form-field
    appearance="outline"
    class="sia-inputs-full sia-input"
    floatLabel="always"
    [class]="inputClass()"
  >
    <mat-label
      >{{ label() | siaTranslate }}
      @if (info()) {
        <span
          [siaTooltip]="info() ?? ''"
          position="right"
          class="sia-info"
          [innerHTML]="infoIcon()"
        >
        </span>
      }
    </mat-label>
    <input
      [id]="id() ?? guid"
      matInput
      [ngModel]="value()"
      (ngModelChange)="value.set($event)"
      [disabled]="isDisabled()"
      #last
      (blur)="onBlur()"
      [placeholder]="placeholder() ?? ''"
      [name]="name() ?? ''"
      autocomplete="on"
      [type]="hide() ? 'password' : 'text'"
    />
    <button
      mat-icon-button
      matSuffix
      (click)="visibility()"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide()"
    >
      <mat-icon>{{ hide() ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </mat-form-field>
}
